import { render, staticRenderFns } from "./listagemProdutos.vue?vue&type=template&id=b7caa110&scoped=true&"
import script from "./listagemProdutos.vue?vue&type=script&lang=js&"
export * from "./listagemProdutos.vue?vue&type=script&lang=js&"
import style0 from "./listagemProdutos.vue?vue&type=style&index=0&id=b7caa110&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7caa110",
  null
  
)

export default component.exports